import { useBrand } from 'hooks/useBrand'
import { useScheduling } from 'hooks/useScheduling'
import When from 'utils/when'
import LoginForm from './LoginForm'
import LoginFormAspaec from './LoginFormAspaec'
import SimplifiedRegisterForm from './SimplifiedRegisterForm'
import { ActionButton, Container, FormHeader } from './styles'

export default function IdentificationStep() {
  const { checkoutFormState, setCheckoutFormState } = useScheduling()
  const { brand } = useBrand()
  const isAspaec = brand === 'aspaec'
  // Marcas whitelabel (Aspaec, Remederi, Vikura) não oferecem login no
  // agendamento — o paciente sempre se cadastra. Só Cannect tem "Entrar".
  const allowLogin = brand === 'cannect'
  const isBranded = brand !== 'cannect'

  return (
    <Container isBranded={isBranded}>
      <FormHeader>
        <h3>Dados do paciente</h3>
        <When expr={allowLogin && checkoutFormState === 'simplified'}>
          <ActionButton className="login-button" type="button" onClick={() => setCheckoutFormState('login')}>
            Entrar
          </ActionButton>
        </When>
        <When expr={allowLogin && checkoutFormState === 'login'}>
          <ActionButton className="login-button" type="button" onClick={() => setCheckoutFormState('simplified')}>
            Cadastre-se
          </ActionButton>
        </When>
      </FormHeader>
      {isBranded && (
        <p className="w-full text-sm text-gray-500">Para dar início a sua jornada, preencha os dados abaixo:</p>
      )}
      {(checkoutFormState === 'simplified' || !allowLogin) && <SimplifiedRegisterForm />}
      {allowLogin && checkoutFormState === 'login' && (isAspaec ? <LoginFormAspaec /> : <LoginForm />)}
    </Container>
  )
}
